/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as TermsRouteImport } from './routes/terms'
import { Route as RefundRouteImport } from './routes/refund'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AuthRouteImport } from './routes/_auth'
import { Route as AppRouteImport } from './routes/_app'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AuthCallbackRouteImport } from './routes/auth.callback'
import { Route as AuthVerifyEmailRouteImport } from './routes/_auth.verify-email'
import { Route as AuthResetPasswordRouteImport } from './routes/_auth.reset-password'
import { Route as AuthLoginRouteImport } from './routes/_auth.login'
import { Route as AuthForgotPasswordRouteImport } from './routes/_auth.forgot-password'
import { Route as AppTeachersRouteImport } from './routes/_app.teachers'
import { Route as AppSuperRouteImport } from './routes/_app.super'
import { Route as AppSettlementsRouteImport } from './routes/_app.settlements'
import { Route as AppMyFeesRouteImport } from './routes/_app.my-fees'
import { Route as AppMyClassesRouteImport } from './routes/_app.my-classes'
import { Route as AppExamsRouteImport } from './routes/_app.exams'
import { Route as AppExamCalendarRouteImport } from './routes/_app.exam-calendar'
import { Route as AppDashboardRouteImport } from './routes/_app.dashboard'
import { Route as AppCommunicateRouteImport } from './routes/_app.communicate'
import { Route as AppClassesRouteImport } from './routes/_app.classes'
import { Route as AppBillingRouteImport } from './routes/_app.billing'
import { Route as AppTestsIndexRouteImport } from './routes/_app.tests.index'
import { Route as AppStudentsIndexRouteImport } from './routes/_app.students.index'
import { Route as AppFeesIndexRouteImport } from './routes/_app.fees.index'
import { Route as AppChildrenIndexRouteImport } from './routes/_app.children.index'
import { Route as AppAuditTrailIndexRouteImport } from './routes/_app.audit-trail.index'
import { Route as AppTestsIdRouteImport } from './routes/_app.tests.$id'
import { Route as AppSuperPlansRouteImport } from './routes/_app.super.plans'
import { Route as AppSuperHealthRouteImport } from './routes/_app.super.health'
import { Route as AppStudentsNewRouteImport } from './routes/_app.students.new'
import { Route as AppStudentsIdRouteImport } from './routes/_app.students.$id'
import { Route as AppSettingsPaymentsRouteImport } from './routes/_app.settings.payments'
import { Route as AppSettingsBrandingRouteImport } from './routes/_app.settings.branding'
import { Route as AppOnboardingRegisterRouteImport } from './routes/_app.onboarding.register'
import { Route as AppFeesNewRouteImport } from './routes/_app.fees.new'
import { Route as AppFeesCategoriesRouteImport } from './routes/_app.fees.categories'
import { Route as AppChildrenIdRouteImport } from './routes/_app.children.$id'
import { Route as AppAttendanceClassIdRouteImport } from './routes/_app.attendance.$classId'
import { Route as AppSuperAuditTrailIndexRouteImport } from './routes/_app.super.audit-trail.index'
import { Route as AppSuperAcademiesIndexRouteImport } from './routes/_app.super.academies.index'
import { Route as AppSuperAcademiesIdRouteImport } from './routes/_app.super.academies.$id'

const TermsRoute = TermsRouteImport.update({
  id: '/terms',
  path: '/terms',
  getParentRoute: () => rootRouteImport,
} as any)
const RefundRoute = RefundRouteImport.update({
  id: '/refund',
  path: '/refund',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRoute = AuthRouteImport.update({
  id: '/_auth',
  getParentRoute: () => rootRouteImport,
} as any)
const AppRoute = AppRouteImport.update({
  id: '/_app',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthCallbackRoute = AuthCallbackRouteImport.update({
  id: '/auth/callback',
  path: '/auth/callback',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthVerifyEmailRoute = AuthVerifyEmailRouteImport.update({
  id: '/verify-email',
  path: '/verify-email',
  getParentRoute: () => AuthRoute,
} as any)
const AuthResetPasswordRoute = AuthResetPasswordRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRoute,
} as any)
const AuthLoginRoute = AuthLoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => AuthRoute,
} as any)
const AuthForgotPasswordRoute = AuthForgotPasswordRouteImport.update({
  id: '/forgot-password',
  path: '/forgot-password',
  getParentRoute: () => AuthRoute,
} as any)
const AppTeachersRoute = AppTeachersRouteImport.update({
  id: '/teachers',
  path: '/teachers',
  getParentRoute: () => AppRoute,
} as any)
const AppSuperRoute = AppSuperRouteImport.update({
  id: '/super',
  path: '/super',
  getParentRoute: () => AppRoute,
} as any)
const AppSettlementsRoute = AppSettlementsRouteImport.update({
  id: '/settlements',
  path: '/settlements',
  getParentRoute: () => AppRoute,
} as any)
const AppMyFeesRoute = AppMyFeesRouteImport.update({
  id: '/my-fees',
  path: '/my-fees',
  getParentRoute: () => AppRoute,
} as any)
const AppMyClassesRoute = AppMyClassesRouteImport.update({
  id: '/my-classes',
  path: '/my-classes',
  getParentRoute: () => AppRoute,
} as any)
const AppExamsRoute = AppExamsRouteImport.update({
  id: '/exams',
  path: '/exams',
  getParentRoute: () => AppRoute,
} as any)
const AppExamCalendarRoute = AppExamCalendarRouteImport.update({
  id: '/exam-calendar',
  path: '/exam-calendar',
  getParentRoute: () => AppRoute,
} as any)
const AppDashboardRoute = AppDashboardRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => AppRoute,
} as any)
const AppCommunicateRoute = AppCommunicateRouteImport.update({
  id: '/communicate',
  path: '/communicate',
  getParentRoute: () => AppRoute,
} as any)
const AppClassesRoute = AppClassesRouteImport.update({
  id: '/classes',
  path: '/classes',
  getParentRoute: () => AppRoute,
} as any)
const AppBillingRoute = AppBillingRouteImport.update({
  id: '/billing',
  path: '/billing',
  getParentRoute: () => AppRoute,
} as any)
const AppTestsIndexRoute = AppTestsIndexRouteImport.update({
  id: '/tests/',
  path: '/tests/',
  getParentRoute: () => AppRoute,
} as any)
const AppStudentsIndexRoute = AppStudentsIndexRouteImport.update({
  id: '/students/',
  path: '/students/',
  getParentRoute: () => AppRoute,
} as any)
const AppFeesIndexRoute = AppFeesIndexRouteImport.update({
  id: '/fees/',
  path: '/fees/',
  getParentRoute: () => AppRoute,
} as any)
const AppChildrenIndexRoute = AppChildrenIndexRouteImport.update({
  id: '/children/',
  path: '/children/',
  getParentRoute: () => AppRoute,
} as any)
const AppAuditTrailIndexRoute = AppAuditTrailIndexRouteImport.update({
  id: '/audit-trail/',
  path: '/audit-trail/',
  getParentRoute: () => AppRoute,
} as any)
const AppTestsIdRoute = AppTestsIdRouteImport.update({
  id: '/tests/$id',
  path: '/tests/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSuperPlansRoute = AppSuperPlansRouteImport.update({
  id: '/plans',
  path: '/plans',
  getParentRoute: () => AppSuperRoute,
} as any)
const AppSuperHealthRoute = AppSuperHealthRouteImport.update({
  id: '/health',
  path: '/health',
  getParentRoute: () => AppSuperRoute,
} as any)
const AppStudentsNewRoute = AppStudentsNewRouteImport.update({
  id: '/students/new',
  path: '/students/new',
  getParentRoute: () => AppRoute,
} as any)
const AppStudentsIdRoute = AppStudentsIdRouteImport.update({
  id: '/students/$id',
  path: '/students/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsPaymentsRoute = AppSettingsPaymentsRouteImport.update({
  id: '/settings/payments',
  path: '/settings/payments',
  getParentRoute: () => AppRoute,
} as any)
const AppSettingsBrandingRoute = AppSettingsBrandingRouteImport.update({
  id: '/settings/branding',
  path: '/settings/branding',
  getParentRoute: () => AppRoute,
} as any)
const AppOnboardingRegisterRoute = AppOnboardingRegisterRouteImport.update({
  id: '/onboarding/register',
  path: '/onboarding/register',
  getParentRoute: () => AppRoute,
} as any)
const AppFeesNewRoute = AppFeesNewRouteImport.update({
  id: '/fees/new',
  path: '/fees/new',
  getParentRoute: () => AppRoute,
} as any)
const AppFeesCategoriesRoute = AppFeesCategoriesRouteImport.update({
  id: '/fees/categories',
  path: '/fees/categories',
  getParentRoute: () => AppRoute,
} as any)
const AppChildrenIdRoute = AppChildrenIdRouteImport.update({
  id: '/children/$id',
  path: '/children/$id',
  getParentRoute: () => AppRoute,
} as any)
const AppAttendanceClassIdRoute = AppAttendanceClassIdRouteImport.update({
  id: '/attendance/$classId',
  path: '/attendance/$classId',
  getParentRoute: () => AppRoute,
} as any)
const AppSuperAuditTrailIndexRoute = AppSuperAuditTrailIndexRouteImport.update({
  id: '/audit-trail/',
  path: '/audit-trail/',
  getParentRoute: () => AppSuperRoute,
} as any)
const AppSuperAcademiesIndexRoute = AppSuperAcademiesIndexRouteImport.update({
  id: '/academies/',
  path: '/academies/',
  getParentRoute: () => AppSuperRoute,
} as any)
const AppSuperAcademiesIdRoute = AppSuperAcademiesIdRouteImport.update({
  id: '/academies/$id',
  path: '/academies/$id',
  getParentRoute: () => AppSuperRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/privacy': typeof PrivacyRoute
  '/refund': typeof RefundRoute
  '/terms': typeof TermsRoute
  '/billing': typeof AppBillingRoute
  '/classes': typeof AppClassesRoute
  '/communicate': typeof AppCommunicateRoute
  '/dashboard': typeof AppDashboardRoute
  '/exam-calendar': typeof AppExamCalendarRoute
  '/exams': typeof AppExamsRoute
  '/my-classes': typeof AppMyClassesRoute
  '/my-fees': typeof AppMyFeesRoute
  '/settlements': typeof AppSettlementsRoute
  '/super': typeof AppSuperRouteWithChildren
  '/teachers': typeof AppTeachersRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/attendance/$classId': typeof AppAttendanceClassIdRoute
  '/children/$id': typeof AppChildrenIdRoute
  '/fees/categories': typeof AppFeesCategoriesRoute
  '/fees/new': typeof AppFeesNewRoute
  '/onboarding/register': typeof AppOnboardingRegisterRoute
  '/settings/branding': typeof AppSettingsBrandingRoute
  '/settings/payments': typeof AppSettingsPaymentsRoute
  '/students/$id': typeof AppStudentsIdRoute
  '/students/new': typeof AppStudentsNewRoute
  '/super/health': typeof AppSuperHealthRoute
  '/super/plans': typeof AppSuperPlansRoute
  '/tests/$id': typeof AppTestsIdRoute
  '/audit-trail/': typeof AppAuditTrailIndexRoute
  '/children/': typeof AppChildrenIndexRoute
  '/fees/': typeof AppFeesIndexRoute
  '/students/': typeof AppStudentsIndexRoute
  '/tests/': typeof AppTestsIndexRoute
  '/super/academies/$id': typeof AppSuperAcademiesIdRoute
  '/super/academies/': typeof AppSuperAcademiesIndexRoute
  '/super/audit-trail/': typeof AppSuperAuditTrailIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/privacy': typeof PrivacyRoute
  '/refund': typeof RefundRoute
  '/terms': typeof TermsRoute
  '/billing': typeof AppBillingRoute
  '/classes': typeof AppClassesRoute
  '/communicate': typeof AppCommunicateRoute
  '/dashboard': typeof AppDashboardRoute
  '/exam-calendar': typeof AppExamCalendarRoute
  '/exams': typeof AppExamsRoute
  '/my-classes': typeof AppMyClassesRoute
  '/my-fees': typeof AppMyFeesRoute
  '/settlements': typeof AppSettlementsRoute
  '/super': typeof AppSuperRouteWithChildren
  '/teachers': typeof AppTeachersRoute
  '/forgot-password': typeof AuthForgotPasswordRoute
  '/login': typeof AuthLoginRoute
  '/reset-password': typeof AuthResetPasswordRoute
  '/verify-email': typeof AuthVerifyEmailRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/attendance/$classId': typeof AppAttendanceClassIdRoute
  '/children/$id': typeof AppChildrenIdRoute
  '/fees/categories': typeof AppFeesCategoriesRoute
  '/fees/new': typeof AppFeesNewRoute
  '/onboarding/register': typeof AppOnboardingRegisterRoute
  '/settings/branding': typeof AppSettingsBrandingRoute
  '/settings/payments': typeof AppSettingsPaymentsRoute
  '/students/$id': typeof AppStudentsIdRoute
  '/students/new': typeof AppStudentsNewRoute
  '/super/health': typeof AppSuperHealthRoute
  '/super/plans': typeof AppSuperPlansRoute
  '/tests/$id': typeof AppTestsIdRoute
  '/audit-trail': typeof AppAuditTrailIndexRoute
  '/children': typeof AppChildrenIndexRoute
  '/fees': typeof AppFeesIndexRoute
  '/students': typeof AppStudentsIndexRoute
  '/tests': typeof AppTestsIndexRoute
  '/super/academies/$id': typeof AppSuperAcademiesIdRoute
  '/super/academies': typeof AppSuperAcademiesIndexRoute
  '/super/audit-trail': typeof AppSuperAuditTrailIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/_app': typeof AppRouteWithChildren
  '/_auth': typeof AuthRouteWithChildren
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/privacy': typeof PrivacyRoute
  '/refund': typeof RefundRoute
  '/terms': typeof TermsRoute
  '/_app/billing': typeof AppBillingRoute
  '/_app/classes': typeof AppClassesRoute
  '/_app/communicate': typeof AppCommunicateRoute
  '/_app/dashboard': typeof AppDashboardRoute
  '/_app/exam-calendar': typeof AppExamCalendarRoute
  '/_app/exams': typeof AppExamsRoute
  '/_app/my-classes': typeof AppMyClassesRoute
  '/_app/my-fees': typeof AppMyFeesRoute
  '/_app/settlements': typeof AppSettlementsRoute
  '/_app/super': typeof AppSuperRouteWithChildren
  '/_app/teachers': typeof AppTeachersRoute
  '/_auth/forgot-password': typeof AuthForgotPasswordRoute
  '/_auth/login': typeof AuthLoginRoute
  '/_auth/reset-password': typeof AuthResetPasswordRoute
  '/_auth/verify-email': typeof AuthVerifyEmailRoute
  '/auth/callback': typeof AuthCallbackRoute
  '/_app/attendance/$classId': typeof AppAttendanceClassIdRoute
  '/_app/children/$id': typeof AppChildrenIdRoute
  '/_app/fees/categories': typeof AppFeesCategoriesRoute
  '/_app/fees/new': typeof AppFeesNewRoute
  '/_app/onboarding/register': typeof AppOnboardingRegisterRoute
  '/_app/settings/branding': typeof AppSettingsBrandingRoute
  '/_app/settings/payments': typeof AppSettingsPaymentsRoute
  '/_app/students/$id': typeof AppStudentsIdRoute
  '/_app/students/new': typeof AppStudentsNewRoute
  '/_app/super/health': typeof AppSuperHealthRoute
  '/_app/super/plans': typeof AppSuperPlansRoute
  '/_app/tests/$id': typeof AppTestsIdRoute
  '/_app/audit-trail/': typeof AppAuditTrailIndexRoute
  '/_app/children/': typeof AppChildrenIndexRoute
  '/_app/fees/': typeof AppFeesIndexRoute
  '/_app/students/': typeof AppStudentsIndexRoute
  '/_app/tests/': typeof AppTestsIndexRoute
  '/_app/super/academies/$id': typeof AppSuperAcademiesIdRoute
  '/_app/super/academies/': typeof AppSuperAcademiesIndexRoute
  '/_app/super/audit-trail/': typeof AppSuperAuditTrailIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/contact'
    | '/privacy'
    | '/refund'
    | '/terms'
    | '/billing'
    | '/classes'
    | '/communicate'
    | '/dashboard'
    | '/exam-calendar'
    | '/exams'
    | '/my-classes'
    | '/my-fees'
    | '/settlements'
    | '/super'
    | '/teachers'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/verify-email'
    | '/auth/callback'
    | '/attendance/$classId'
    | '/children/$id'
    | '/fees/categories'
    | '/fees/new'
    | '/onboarding/register'
    | '/settings/branding'
    | '/settings/payments'
    | '/students/$id'
    | '/students/new'
    | '/super/health'
    | '/super/plans'
    | '/tests/$id'
    | '/audit-trail/'
    | '/children/'
    | '/fees/'
    | '/students/'
    | '/tests/'
    | '/super/academies/$id'
    | '/super/academies/'
    | '/super/audit-trail/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/contact'
    | '/privacy'
    | '/refund'
    | '/terms'
    | '/billing'
    | '/classes'
    | '/communicate'
    | '/dashboard'
    | '/exam-calendar'
    | '/exams'
    | '/my-classes'
    | '/my-fees'
    | '/settlements'
    | '/super'
    | '/teachers'
    | '/forgot-password'
    | '/login'
    | '/reset-password'
    | '/verify-email'
    | '/auth/callback'
    | '/attendance/$classId'
    | '/children/$id'
    | '/fees/categories'
    | '/fees/new'
    | '/onboarding/register'
    | '/settings/branding'
    | '/settings/payments'
    | '/students/$id'
    | '/students/new'
    | '/super/health'
    | '/super/plans'
    | '/tests/$id'
    | '/audit-trail'
    | '/children'
    | '/fees'
    | '/students'
    | '/tests'
    | '/super/academies/$id'
    | '/super/academies'
    | '/super/audit-trail'
  id:
    | '__root__'
    | '/'
    | '/_app'
    | '/_auth'
    | '/about'
    | '/contact'
    | '/privacy'
    | '/refund'
    | '/terms'
    | '/_app/billing'
    | '/_app/classes'
    | '/_app/communicate'
    | '/_app/dashboard'
    | '/_app/exam-calendar'
    | '/_app/exams'
    | '/_app/my-classes'
    | '/_app/my-fees'
    | '/_app/settlements'
    | '/_app/super'
    | '/_app/teachers'
    | '/_auth/forgot-password'
    | '/_auth/login'
    | '/_auth/reset-password'
    | '/_auth/verify-email'
    | '/auth/callback'
    | '/_app/attendance/$classId'
    | '/_app/children/$id'
    | '/_app/fees/categories'
    | '/_app/fees/new'
    | '/_app/onboarding/register'
    | '/_app/settings/branding'
    | '/_app/settings/payments'
    | '/_app/students/$id'
    | '/_app/students/new'
    | '/_app/super/health'
    | '/_app/super/plans'
    | '/_app/tests/$id'
    | '/_app/audit-trail/'
    | '/_app/children/'
    | '/_app/fees/'
    | '/_app/students/'
    | '/_app/tests/'
    | '/_app/super/academies/$id'
    | '/_app/super/academies/'
    | '/_app/super/audit-trail/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AppRoute: typeof AppRouteWithChildren
  AuthRoute: typeof AuthRouteWithChildren
  AboutRoute: typeof AboutRoute
  ContactRoute: typeof ContactRoute
  PrivacyRoute: typeof PrivacyRoute
  RefundRoute: typeof RefundRoute
  TermsRoute: typeof TermsRoute
  AuthCallbackRoute: typeof AuthCallbackRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/terms': {
      id: '/terms'
      path: '/terms'
      fullPath: '/terms'
      preLoaderRoute: typeof TermsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/refund': {
      id: '/refund'
      path: '/refund'
      fullPath: '/refund'
      preLoaderRoute: typeof RefundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth': {
      id: '/_auth'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AuthRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_app': {
      id: '/_app'
      path: ''
      fullPath: '/'
      preLoaderRoute: typeof AppRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth/callback': {
      id: '/auth/callback'
      path: '/auth/callback'
      fullPath: '/auth/callback'
      preLoaderRoute: typeof AuthCallbackRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/_auth/verify-email': {
      id: '/_auth/verify-email'
      path: '/verify-email'
      fullPath: '/verify-email'
      preLoaderRoute: typeof AuthVerifyEmailRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/reset-password': {
      id: '/_auth/reset-password'
      path: '/reset-password'
      fullPath: '/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/login': {
      id: '/_auth/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof AuthLoginRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_auth/forgot-password': {
      id: '/_auth/forgot-password'
      path: '/forgot-password'
      fullPath: '/forgot-password'
      preLoaderRoute: typeof AuthForgotPasswordRouteImport
      parentRoute: typeof AuthRoute
    }
    '/_app/teachers': {
      id: '/_app/teachers'
      path: '/teachers'
      fullPath: '/teachers'
      preLoaderRoute: typeof AppTeachersRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/super': {
      id: '/_app/super'
      path: '/super'
      fullPath: '/super'
      preLoaderRoute: typeof AppSuperRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settlements': {
      id: '/_app/settlements'
      path: '/settlements'
      fullPath: '/settlements'
      preLoaderRoute: typeof AppSettlementsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-fees': {
      id: '/_app/my-fees'
      path: '/my-fees'
      fullPath: '/my-fees'
      preLoaderRoute: typeof AppMyFeesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/my-classes': {
      id: '/_app/my-classes'
      path: '/my-classes'
      fullPath: '/my-classes'
      preLoaderRoute: typeof AppMyClassesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/exams': {
      id: '/_app/exams'
      path: '/exams'
      fullPath: '/exams'
      preLoaderRoute: typeof AppExamsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/exam-calendar': {
      id: '/_app/exam-calendar'
      path: '/exam-calendar'
      fullPath: '/exam-calendar'
      preLoaderRoute: typeof AppExamCalendarRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/dashboard': {
      id: '/_app/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof AppDashboardRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/communicate': {
      id: '/_app/communicate'
      path: '/communicate'
      fullPath: '/communicate'
      preLoaderRoute: typeof AppCommunicateRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/classes': {
      id: '/_app/classes'
      path: '/classes'
      fullPath: '/classes'
      preLoaderRoute: typeof AppClassesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/billing': {
      id: '/_app/billing'
      path: '/billing'
      fullPath: '/billing'
      preLoaderRoute: typeof AppBillingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tests/': {
      id: '/_app/tests/'
      path: '/tests'
      fullPath: '/tests/'
      preLoaderRoute: typeof AppTestsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/students/': {
      id: '/_app/students/'
      path: '/students'
      fullPath: '/students/'
      preLoaderRoute: typeof AppStudentsIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fees/': {
      id: '/_app/fees/'
      path: '/fees'
      fullPath: '/fees/'
      preLoaderRoute: typeof AppFeesIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/children/': {
      id: '/_app/children/'
      path: '/children'
      fullPath: '/children/'
      preLoaderRoute: typeof AppChildrenIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/audit-trail/': {
      id: '/_app/audit-trail/'
      path: '/audit-trail'
      fullPath: '/audit-trail/'
      preLoaderRoute: typeof AppAuditTrailIndexRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/tests/$id': {
      id: '/_app/tests/$id'
      path: '/tests/$id'
      fullPath: '/tests/$id'
      preLoaderRoute: typeof AppTestsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/super/plans': {
      id: '/_app/super/plans'
      path: '/plans'
      fullPath: '/super/plans'
      preLoaderRoute: typeof AppSuperPlansRouteImport
      parentRoute: typeof AppSuperRoute
    }
    '/_app/super/health': {
      id: '/_app/super/health'
      path: '/health'
      fullPath: '/super/health'
      preLoaderRoute: typeof AppSuperHealthRouteImport
      parentRoute: typeof AppSuperRoute
    }
    '/_app/students/new': {
      id: '/_app/students/new'
      path: '/students/new'
      fullPath: '/students/new'
      preLoaderRoute: typeof AppStudentsNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/students/$id': {
      id: '/_app/students/$id'
      path: '/students/$id'
      fullPath: '/students/$id'
      preLoaderRoute: typeof AppStudentsIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/payments': {
      id: '/_app/settings/payments'
      path: '/settings/payments'
      fullPath: '/settings/payments'
      preLoaderRoute: typeof AppSettingsPaymentsRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/settings/branding': {
      id: '/_app/settings/branding'
      path: '/settings/branding'
      fullPath: '/settings/branding'
      preLoaderRoute: typeof AppSettingsBrandingRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/onboarding/register': {
      id: '/_app/onboarding/register'
      path: '/onboarding/register'
      fullPath: '/onboarding/register'
      preLoaderRoute: typeof AppOnboardingRegisterRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fees/new': {
      id: '/_app/fees/new'
      path: '/fees/new'
      fullPath: '/fees/new'
      preLoaderRoute: typeof AppFeesNewRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/fees/categories': {
      id: '/_app/fees/categories'
      path: '/fees/categories'
      fullPath: '/fees/categories'
      preLoaderRoute: typeof AppFeesCategoriesRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/children/$id': {
      id: '/_app/children/$id'
      path: '/children/$id'
      fullPath: '/children/$id'
      preLoaderRoute: typeof AppChildrenIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/attendance/$classId': {
      id: '/_app/attendance/$classId'
      path: '/attendance/$classId'
      fullPath: '/attendance/$classId'
      preLoaderRoute: typeof AppAttendanceClassIdRouteImport
      parentRoute: typeof AppRoute
    }
    '/_app/super/audit-trail/': {
      id: '/_app/super/audit-trail/'
      path: '/audit-trail'
      fullPath: '/super/audit-trail/'
      preLoaderRoute: typeof AppSuperAuditTrailIndexRouteImport
      parentRoute: typeof AppSuperRoute
    }
    '/_app/super/academies/': {
      id: '/_app/super/academies/'
      path: '/academies'
      fullPath: '/super/academies/'
      preLoaderRoute: typeof AppSuperAcademiesIndexRouteImport
      parentRoute: typeof AppSuperRoute
    }
    '/_app/super/academies/$id': {
      id: '/_app/super/academies/$id'
      path: '/academies/$id'
      fullPath: '/super/academies/$id'
      preLoaderRoute: typeof AppSuperAcademiesIdRouteImport
      parentRoute: typeof AppSuperRoute
    }
  }
}

interface AppSuperRouteChildren {
  AppSuperHealthRoute: typeof AppSuperHealthRoute
  AppSuperPlansRoute: typeof AppSuperPlansRoute
  AppSuperAcademiesIdRoute: typeof AppSuperAcademiesIdRoute
  AppSuperAcademiesIndexRoute: typeof AppSuperAcademiesIndexRoute
  AppSuperAuditTrailIndexRoute: typeof AppSuperAuditTrailIndexRoute
}

const AppSuperRouteChildren: AppSuperRouteChildren = {
  AppSuperHealthRoute: AppSuperHealthRoute,
  AppSuperPlansRoute: AppSuperPlansRoute,
  AppSuperAcademiesIdRoute: AppSuperAcademiesIdRoute,
  AppSuperAcademiesIndexRoute: AppSuperAcademiesIndexRoute,
  AppSuperAuditTrailIndexRoute: AppSuperAuditTrailIndexRoute,
}

const AppSuperRouteWithChildren = AppSuperRoute._addFileChildren(
  AppSuperRouteChildren,
)

interface AppRouteChildren {
  AppBillingRoute: typeof AppBillingRoute
  AppClassesRoute: typeof AppClassesRoute
  AppCommunicateRoute: typeof AppCommunicateRoute
  AppDashboardRoute: typeof AppDashboardRoute
  AppExamCalendarRoute: typeof AppExamCalendarRoute
  AppExamsRoute: typeof AppExamsRoute
  AppMyClassesRoute: typeof AppMyClassesRoute
  AppMyFeesRoute: typeof AppMyFeesRoute
  AppSettlementsRoute: typeof AppSettlementsRoute
  AppSuperRoute: typeof AppSuperRouteWithChildren
  AppTeachersRoute: typeof AppTeachersRoute
  AppAttendanceClassIdRoute: typeof AppAttendanceClassIdRoute
  AppChildrenIdRoute: typeof AppChildrenIdRoute
  AppFeesCategoriesRoute: typeof AppFeesCategoriesRoute
  AppFeesNewRoute: typeof AppFeesNewRoute
  AppOnboardingRegisterRoute: typeof AppOnboardingRegisterRoute
  AppSettingsBrandingRoute: typeof AppSettingsBrandingRoute
  AppSettingsPaymentsRoute: typeof AppSettingsPaymentsRoute
  AppStudentsIdRoute: typeof AppStudentsIdRoute
  AppStudentsNewRoute: typeof AppStudentsNewRoute
  AppTestsIdRoute: typeof AppTestsIdRoute
  AppAuditTrailIndexRoute: typeof AppAuditTrailIndexRoute
  AppChildrenIndexRoute: typeof AppChildrenIndexRoute
  AppFeesIndexRoute: typeof AppFeesIndexRoute
  AppStudentsIndexRoute: typeof AppStudentsIndexRoute
  AppTestsIndexRoute: typeof AppTestsIndexRoute
}

const AppRouteChildren: AppRouteChildren = {
  AppBillingRoute: AppBillingRoute,
  AppClassesRoute: AppClassesRoute,
  AppCommunicateRoute: AppCommunicateRoute,
  AppDashboardRoute: AppDashboardRoute,
  AppExamCalendarRoute: AppExamCalendarRoute,
  AppExamsRoute: AppExamsRoute,
  AppMyClassesRoute: AppMyClassesRoute,
  AppMyFeesRoute: AppMyFeesRoute,
  AppSettlementsRoute: AppSettlementsRoute,
  AppSuperRoute: AppSuperRouteWithChildren,
  AppTeachersRoute: AppTeachersRoute,
  AppAttendanceClassIdRoute: AppAttendanceClassIdRoute,
  AppChildrenIdRoute: AppChildrenIdRoute,
  AppFeesCategoriesRoute: AppFeesCategoriesRoute,
  AppFeesNewRoute: AppFeesNewRoute,
  AppOnboardingRegisterRoute: AppOnboardingRegisterRoute,
  AppSettingsBrandingRoute: AppSettingsBrandingRoute,
  AppSettingsPaymentsRoute: AppSettingsPaymentsRoute,
  AppStudentsIdRoute: AppStudentsIdRoute,
  AppStudentsNewRoute: AppStudentsNewRoute,
  AppTestsIdRoute: AppTestsIdRoute,
  AppAuditTrailIndexRoute: AppAuditTrailIndexRoute,
  AppChildrenIndexRoute: AppChildrenIndexRoute,
  AppFeesIndexRoute: AppFeesIndexRoute,
  AppStudentsIndexRoute: AppStudentsIndexRoute,
  AppTestsIndexRoute: AppTestsIndexRoute,
}

const AppRouteWithChildren = AppRoute._addFileChildren(AppRouteChildren)

interface AuthRouteChildren {
  AuthForgotPasswordRoute: typeof AuthForgotPasswordRoute
  AuthLoginRoute: typeof AuthLoginRoute
  AuthResetPasswordRoute: typeof AuthResetPasswordRoute
  AuthVerifyEmailRoute: typeof AuthVerifyEmailRoute
}

const AuthRouteChildren: AuthRouteChildren = {
  AuthForgotPasswordRoute: AuthForgotPasswordRoute,
  AuthLoginRoute: AuthLoginRoute,
  AuthResetPasswordRoute: AuthResetPasswordRoute,
  AuthVerifyEmailRoute: AuthVerifyEmailRoute,
}

const AuthRouteWithChildren = AuthRoute._addFileChildren(AuthRouteChildren)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AppRoute: AppRouteWithChildren,
  AuthRoute: AuthRouteWithChildren,
  AboutRoute: AboutRoute,
  ContactRoute: ContactRoute,
  PrivacyRoute: PrivacyRoute,
  RefundRoute: RefundRoute,
  TermsRoute: TermsRoute,
  AuthCallbackRoute: AuthCallbackRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
